import { NavLink, Outlet, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { TbUsersGroup } from "react-icons/tb";

import { ThemeProvider } from "@/providers/theme-provider";
import { ThemeToggle } from "@/components/theme-toggle/theme-toggle";
import { Button } from "@/components/ui/button/button";
import { getCurrentTeamLeaderQueryOptions } from "@/config/queries/teamleader/tl-query-options";
import { cn } from "@/lib/utils";

const LINKS = [
  { to: "/teamleader", label: "Today", end: true },
  { to: "/teamleader/summary", label: "Break summary", end: false },
  { to: "/teamleader/attendance", label: "Present / absent", end: false },
];

export default function TeamLeaderLayout() {
  const key = Cookies.get("key") as string;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data } = useQuery(getCurrentTeamLeaderQueryOptions(key));

  const logout = () => {
    Cookies.remove("key");
    localStorage.clear();
    queryClient.clear();
    toast.success("Log out Success!");
    navigate("/", { replace: true });
  };

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background">
        <header className="h-14 bg-muted flex items-center px-5 gap-4 border-b">
          <div className="flex items-center gap-2 font-semibold">
            <TbUsersGroup className="w-5 h-5" />
            Team Leader
          </div>
          <nav className="flex items-center gap-1 ml-4">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  cn(
                    "px-3 py-1.5 rounded-md text-sm transition-colors",
                    isActive ? "bg-primary text-primary-foreground" : "hover:bg-ring/10"
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3 ml-auto">
            <ThemeToggle />
            <span className="hidden sm:block text-sm text-muted-foreground">
              {data?.foundTeamLeader?.name || data?.foundTeamLeader?.email}
            </span>
            <Button size="sm" variant="outline" onClick={logout} data-testid="tl-logout">
              Log out
            </Button>
          </div>
        </header>

        <main className="p-5">
          <Outlet />
        </main>
      </div>
    </ThemeProvider>
  );
}
